import React from 'react'

const Home = () => {
  return (
    <div className='page-content'>Home</div>
  )
}

export default Home